// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Validates the pointOfSale parameter. Throws an error if parameter is empty
 * @param pointOfSale - The pointOfSale passed from the init settings.
 * @returns - The retrieved pointOfSale attribute to be sent to the API
 */
function getPointOfSale(pointOfSale) {
    if (pointOfSale && pointOfSale.trim().length > 0)
        return pointOfSale;
    throw Error('[MV-0003] "pointOfSale" is required.');
}

export { getPointOfSale };
